import myTitle from './myTitle'

const title = {
  install(Vue) {
    Vue.component(myTitle.name, myTitle)
  }
}

export default title
